import { render, staticRenderFns } from "./productEvaluation.vue?vue&type=template&id=0c42e1a8&scoped=true"
import script from "./productEvaluation.vue?vue&type=script&lang=js"
export * from "./productEvaluation.vue?vue&type=script&lang=js"
import style0 from "./productEvaluation.vue?vue&type=style&index=0&id=0c42e1a8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c42e1a8",
  null
  
)

export default component.exports